import React from "react";

const Roles = () => {
  return (
    <div>
      <div>Roles</div>
    </div>
  );
};

export default Roles;
